import { MarketCard, EventGroup, CreationContext } from "../../types";

export function createOfferCard(
  _: EventGroup[],
  context: CreationContext
): Array<MarketCard> {
  if (!context.displayOfferCard) return [];

  const offer = new MarketCard({
    type: "offer",
    eventId: "",
    marketIds: [],
    optionIds: null
  });

  return [offer];
}
